import React from 'react';
import SectionSurface from '../shared/SectionSurface';

export default function CloseContextGap() {
  return (
    <SectionSurface
      variant="default"
      decor="none"
      bleed="none"
      className="bg-[linear-gradient(135deg,#111827_0%,#243047_55%,#0f172a_100%)]"
    >
      <div className="container-x py-8 sm:py-10 lg:py-12">
        <div className="mx-auto max-w-6xl rounded-[28px] bg-white/95 p-6 shadow-[0_24px_70px_rgba(15,23,42,0.22)] ring-1 ring-white/20 sm:p-8 lg:p-10">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.15fr_0.85fr] lg:gap-12">
            <div>
              <div className="mb-4 h-1.5 w-16 rounded-full bg-gradient-to-r from-brand-500 to-accent-400" />
              <p className="eyebrow">Close the Context Gap</p>
              <h2 className="mt-3 max-w-2xl text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">
                Close the Context Gap Between Data and Decisions
              </h2>

              <p className="mt-4 text-sm leading-6 text-ink-700">
                Enterprises do not lack data. They lack shared understanding.
              </p>
              <p className="mt-3 text-sm leading-6 text-ink-600">
                Metrics live in dashboards, business rules live in pipelines, definitions live in documents, and domain expertise lives with people. MyOrgLab turns fragmented knowledge into semantic memory that AI systems, BI platforms, and business teams can understand consistently.
              </p>

              <div className="mt-5 flex flex-wrap gap-2">
                <span className="badge-brand">Metrics</span>
                <span className="badge-semantic">Business Rules</span>
                <span className="badge-enterprise">Domain Knowledge</span>
              </div>
            </div>

            <div className="rounded-2xl bg-surface-subtle p-4 ring-1 ring-ink-200 sm:p-5">
              <p className="text-xs font-semibold uppercase tracking-[0.12em] text-ink-500">
                Fragmented Inputs -> Semantic Foundation -> Trusted Decisions
              </p>

              <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-3">
                <div className="rounded-xl bg-white p-3 ring-1 ring-ink-200">
                  <p className="text-xs font-semibold uppercase tracking-wide text-ink-500">Inputs</p>
                  <div className="mt-2 flex flex-wrap gap-1.5">
                    <span className="badge-neutral">Dashboards</span>
                    <span className="badge-neutral">Pipelines</span>
                    <span className="badge-neutral">Documents</span>
                    <span className="badge-neutral">Metrics</span>
                    <span className="badge-neutral">SME Knowledge</span>
                  </div>
                </div>

                <div className="rounded-xl bg-brand-50/70 p-3 ring-1 ring-brand-100">
                  <p className="text-xs font-semibold uppercase tracking-wide text-brand-700">Semantic Foundation</p>
                  <div className="mt-2 flex flex-wrap gap-1.5">
                    <span className="badge-brand">Semantic Layer</span>
                    <span className="badge-brand">Enterprise Memory</span>
                    <span className="badge-brand">Governed Definitions</span>
                  </div>
                </div>

                <div className="rounded-xl bg-accent-50/70 p-3 ring-1 ring-accent-100">
                  <p className="text-xs font-semibold uppercase tracking-wide text-accent-700">Outputs</p>
                  <div className="mt-2 flex flex-wrap gap-1.5">
                    <span className="badge-accent">AI Agents</span>
                    <span className="badge-accent">Conversational BI</span>
                    <span className="badge-accent">Decision Intelligence</span>
                    <span className="badge-accent">Dashboard Marketplace</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionSurface>
  );
}
